import React from 'react';
import { Image, Text } from '@goodfynd/react-web.lib.ui';
import { Grid } from '@mui/material';

import images from '../../../config/images';
import strings from '../../../config/strings';

import { StyledContainer, StyledDescription, StyledItem } from './styles';

import classes from './PanelBenefits.module.css';

type BlockItem = {
  description: string;
  external?: boolean;
  image: string;
  showTtitle?: boolean;
  title: string;
  url?: string;
};

const renderBlock = (item: BlockItem) => (
  <Grid item lg={3} sm={6} xs={12}>
    {renderBlockContent(item)}
  </Grid>
);

const renderBlockContent = (item: BlockItem) => (
  <StyledItem>
    <Image alt={item.title} height={65} src={item.image} width={75} />
    <aside style={{ flex: 1 }}>
      <Text as="subhead1" className={classes.title}>
        {item.title}
      </Text>
      <StyledDescription as="body2">{item.description}</StyledDescription>
    </aside>
  </StyledItem>
);

export default function PanelBenefits() {
  return (
    <StyledContainer>
      <Text as="heading3">{strings.titles.ourBenefits}</Text>

      <Grid container spacing={4}>
        {renderBlock({
          image: images.icons.pto,
          title: 'Unlimited Paid Time Off',
          description: `Startup life is mad real, so take a break when you need it! (10 day minimum) `,
        })}

        {renderBlock({
          image: images.icons.lifestyle,
          title: 'Lifestyle Benefits',
          description: `Netflix and chill, Hulu binge, need a Lyft? Enjoy fun lifestyle benefits on us!`,
        })}

        {renderBlock({
          image: images.icons.health,
          title: 'Comprehensive Health',
          description: `Medical, dental, vision, 401k and life insurance.`,
        })}

        {renderBlock({
          image: images.icons.proDev,
          title: 'Professional Development',
          description: `Knowledge is power! All employees receive an annual allowance up to $1,000 to learn something new. `,
        })}

        {renderBlock({
          image: images.icons.remoteWork,
          title: 'Remote Work',
          description: `Enjoy two days a week at home when the office reopens in 2022. All employees will be remote until January. `,
        })}

        {renderBlock({
          image: images.icons.schedule,
          title: 'Flex Work Schedule',
          description: `We know you’ll get the job done; pick a work schedule that fits your life. 8 hour days or 10 hour days and take every other Friday off. `,
        })}

        {renderBlock({
          image: images.icons.perks,
          title: 'Goodfynd Perks',
          description: `$50 a month in Goodfynd credits to order from any food truck on our platform.`,
        })}
      </Grid>
    </StyledContainer>
  );
}
